import * as React from 'react'


export const LandTag = ({ locationName } : {locationName: string}) => {
    return <p className="tag__land">{locationName}</p>
}

